import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Refresh icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Refresh } from '@sravni/design-system-icons'
 *
 * <Refresh />
 * ```
 */
var Refresh = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Refresh", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M7.083 5H10a6.25 6.25 0 1 1-5.555 3.383", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M9.583 2.5 7.083 5l2.5 2.5", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Refresh };
//# sourceMappingURL=Refresh.js.map
